import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b border-[#003264]/10 bg-white ${
      isScrolled ? 'shadow-sm' : ''
    }`}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/e7596bc6af9def0d5965eecdb80c30c5/2b2bc04ba94a41c14b0a5b63e1f16481.jpeg" 
              alt="Exalt Ventures Ltd." 
              className="h-8 sm:h-10"
            />
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-8">
            <Link 
              to="/" 
              className={`text-xs font-semibold tracking-wider transition-colors whitespace-nowrap ${
                isActive('/') ? 'text-[#64C8FA]' : 'text-[#003264] hover:text-[#64C8FA]'
              }`}
            >
              HOME
            </Link>
            <Link 
              to="/about" 
              className={`text-xs font-semibold tracking-wider transition-colors whitespace-nowrap ${
                isActive('/about') ? 'text-[#64C8FA]' : 'text-[#003264] hover:text-[#64C8FA]'
              }`}
            >
              ABOUT EXALT
            </Link>
            <Link 
              to="/brands" 
              className={`text-xs font-semibold tracking-wider transition-colors whitespace-nowrap ${
                isActive('/brands') ? 'text-[#64C8FA]' : 'text-[#003264] hover:text-[#64C8FA]'
              }`}
            >
              OUR BRANDS
            </Link>
            <Link 
              to="/markets" 
              className={`text-xs font-semibold tracking-wider transition-colors whitespace-nowrap ${
                isActive('/markets') ? 'text-[#64C8FA]' : 'text-[#003264] hover:text-[#64C8FA]'
              }`}
            >
              MARKETS
            </Link>
            <Link 
              to="/digital" 
              className={`text-xs font-semibold tracking-wider transition-colors whitespace-nowrap ${
                isActive('/digital') ? 'text-[#64C8FA]' : 'text-[#003264] hover:text-[#64C8FA]'
              }`}
            >
              DIGITAL PRESENCE
            </Link>
            <Link 
              to="/contact" 
              className={`text-xs font-semibold tracking-wider transition-colors whitespace-nowrap ${
                isActive('/contact') ? 'text-[#64C8FA]' : 'text-[#003264] hover:text-[#64C8FA]'
              }`}
            >
              CONTACT
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-[#003264] cursor-pointer"
            aria-label="Toggle menu"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-[#003264]/10">
            <div className="flex flex-col gap-4 pt-4">
              <Link 
                to="/" 
                className={`text-sm font-semibold tracking-wider transition-colors ${
                  isActive('/') ? 'text-[#64C8FA]' : 'text-[#003264]'
                }`}
              >
                HOME
              </Link>
              <Link 
                to="/about" 
                className={`text-sm font-semibold tracking-wider transition-colors ${
                  isActive('/about') ? 'text-[#64C8FA]' : 'text-[#003264]'
                }`}
              >
                ABOUT EXALT
              </Link>
              <Link 
                to="/brands" 
                className={`text-sm font-semibold tracking-wider transition-colors ${
                  isActive('/brands') ? 'text-[#64C8FA]' : 'text-[#003264]'
                }`}
              >
                OUR BRANDS
              </Link>
              <Link 
                to="/markets" 
                className={`text-sm font-semibold tracking-wider transition-colors ${
                  isActive('/markets') ? 'text-[#64C8FA]' : 'text-[#003264]'
                }`}
              >
                MARKETS
              </Link>
              <Link 
                to="/digital" 
                className={`text-sm font-semibold tracking-wider transition-colors ${
                  isActive('/digital') ? 'text-[#64C8FA]' : 'text-[#003264]'
                }`}
              >
                DIGITAL PRESENCE
              </Link>
              <Link 
                to="/contact" 
                className={`text-sm font-semibold tracking-wider transition-colors ${
                  isActive('/contact') ? 'text-[#64C8FA]' : 'text-[#003264]'
                }`}
              >
                CONTACT
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
